import clsx from "clsx"
import { forwardRef } from "react"

import { faIcon } from "@utils/faIcon"

import { Button } from "@atoms"

import { FileThumbnail } from "@molecules"

import styles from "./DocumentDownload.module.scss"
import { DocumentDownloadProps } from "./DocumentDownload.types"

function DocumentDownload(props: DocumentDownloadProps, ref: React.Ref<HTMLDivElement>) {
    const { src, filename, mimeType, className } = props

    const handleDownload = () => {
        window.open(src, "_blank")
    }

    return (
        <div ref={ref} className={clsx(styles.container, className)}>
            <div className={styles.iconCopyWrapper}>
                <div className="light-theme">
                    <FileThumbnail mimeType={mimeType} filename={filename} />
                </div>

                <div className={styles.copy}>
                    <span className={styles.title}>Couldn&apos;t preview this file.</span>
                    <span className={styles.subtitle}>Try to download it instead.</span>
                </div>
            </div>
            <Button
                size="lg"
                variant="subtle"
                leftIcon={faIcon({ name: "download", style: "regular" })}
                onClick={handleDownload}
            >
                Download
            </Button>
        </div>
    )
}

export default forwardRef(DocumentDownload)
